import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getPersonalDetailsVerificationPath = () => {
  return urlHelper('/auth/personal-details-verification');
};
